
import * as Yup from 'yup';

import { addYupCustomRegex, isRequiredValidation } from '@ulta/utils/Validations/Validations';

// This should probably be done once at app startup, but for now, let's put it here.
Yup.addMethod( Yup.string, 'isRequiredField', isRequiredValidation );

/**
* Creates a Yup validation schema from a configuration object.
* @param {object} fields - The fields props from DXL, containing validations array for custom regex.
* @returns {Yup.ObjectSchema} - The Yup validation schema.
*/
export const createYupSchema = ( fields = {} ) => {
  const shape = {};

  for ( const fieldName in fields ){
    if( Object.prototype.hasOwnProperty.call( fields, fieldName ) ){
      const validationConfig = fields[fieldName];

      let validator;

      // Determine the base Yup schema type
      switch ( validationConfig?.type ){
        case 'number':
          validator = Yup.number();
          break;
        case 'date':
          validator = Yup.date();
          break;
        case 'boolean':
          validator = Yup.boolean();
          break;
        case 'array':
          validator = Yup.array();
          break;
        case 'tel':
          validator = Yup.string();
          break;
        case 'text':
        default:
          validator = Yup.string();
          break;
      }

      // Apply 'required' validation first to ensure it's the first error message shown for empty fields.
      if( validationConfig?.required ){
        const params = validationConfig.required ? 'Required' : null;
        validator = Array.isArray( params ) ? validator.required( ...params ) : validator.required( params );
      }

      if( validationConfig?.isDependentField ){
        if( validationConfig?.name === 'confirmPassword' ){
          validator = validator.oneOf( [Yup.ref( 'password' ), null], 'Passwords do not match' );
        }
      }

      // Add custom DXL regex validations.
      if( fields[fieldName]?.validations ){
        addYupCustomRegex( {
          schemaType: Yup.string,
          name: fieldName,
          validations: fields[fieldName].validations
        } );
        if( typeof validator[fieldName] === 'function' ){
          validator = validator[fieldName]();
        }
      }

      // Apply standard validation rules from the config
      for ( const rule in validationConfig ){
        if( Object.prototype.hasOwnProperty.call( validationConfig, rule ) && rule !== 'type' && rule !== 'required' ){
          const params = validationConfig[rule];
          if( params !== undefined && typeof validator[rule] === 'function' ){
            validator = Array.isArray( params ) ? validator[rule]( ...params ) : validator[rule]( params );
          }
        }
      }
      shape[fieldName] = validator;
    }
  }

  return Yup.object().shape( shape );
};
